import { type FC, useEffect } from 'react';
import { useDialogHelpers } from '@/components/feedback/useDialogHelpers';

interface ConfirmModalProps {
  show: boolean;
  title: string;
  confirm: () => void;
  cancel: () => void;
  okText?: string;
}

/**
 * Wrapper component for backward compatibility
 * Uses the new dialog system under the hood
 */
export const ConfirmModal: FC<ConfirmModalProps> = ({
  okText,
  show,
  title,
  confirm,
  cancel,
}) => {
  const { showDialog, hideAllDialogs } = useDialogHelpers();

  useEffect(() => {
    if (show) {
      showDialog({
        title,
        type: 'confirm',
        confirmText: okText,
        onConfirm: confirm,
        onCancel: cancel,
      });
    } else {
      // Clean up any existing dialogs when show becomes false
      hideAllDialogs();
    }
  }, [show]);

  // This component no longer renders anything directly
  // The dialog is rendered by DialogProvider
  return null;
};
